// modules
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { RouterModule } from "@angular/router";

// directives
import { ElementFocus } from "./directives/element-focus.directive";
import { StickDirective } from "./directives/stick.directive";

// pipes
import { ReplaceQuotesPipe } from "./pipes/replace-quotes.pipe";

// components
import { TooltipComponent } from "./tooltip/tooltip.component";
import { TagButtonComponent } from "./tag-button/tag-button.component";
import { TagBarComponent } from "./tag-bar/tag-bar.component";
import { CourseCardComponent } from "./course-card/course-card.component";

/* Feature Modules */
import { ClipboardModule } from "angular2-clipboard";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		HttpModule,
		RouterModule,
		ClipboardModule
	],
	declarations: [
		TagBarComponent,
		CourseCardComponent,
		TooltipComponent,
		TagButtonComponent,
		ReplaceQuotesPipe,
		ElementFocus,
		StickDirective
	],
	exports: [
		TagBarComponent,
		CourseCardComponent,
		TooltipComponent,
		TagButtonComponent,
		ReplaceQuotesPipe,
		ElementFocus,
		StickDirective
	]
})
export class SharedModule {}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/shared.module.ts